<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Ward Preview"
      id="admin_delete_ward_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn @click="$router.go(-1)" small rounded outlined color="default">
        <v-icon left>mdi-trash-can</v-icon> Cancel Delete
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="ward.name"
        :icon="'mdi-flag'"
        :img_src="'https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1605951043/botswana%20services/website%20assets/ward_w66wvu.png'"
        :facts="view_header_facts"
        :description="''"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-trash-can"
      label="Delete Ward Concent Form "
      id="admin_delete_ward_form"
    ></CardedSectionHeader>
    <DeleteConcentForm
      ref_prop="wards_delete_form_ref"
      id="wards_delete_form"
      message="<b>Delete was succesfull</b> <br/> Ward has been removed"
      :is_loading="is_loading"
      :seed="{ward:[$route.params.id]}"
      @on-delete-success="on_success"
      @on-hide-loader="$emit('on-hide-loader')"
      @on-show-loader="$emit('on-show-loader')"
    >
    </DeleteConcentForm>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import CardedForm from "../../../components/CardedForm";
import ViewHeader from "../../../components/ViewHeader";
import DeleteConcentForm from "../../../components/DeleteConcentForm";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminWardsDelete",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    ViewHeader,
    CardedForm,
    DeleteConcentForm
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      ward: {
        id: 0,
        name: "",
        country: {
            id: 0,
            name: ""
        },
        district: {
            id: 0,
            name: ""
        },
        city: {
            id: 0,
            name: ""
        }
      },
      errors: [],
      message: "",
      not_found: false,
      records: null,
      total: 0,
      scan_limit: 0,
    };
  },
  methods: {
    on_success() {
      //go back to wards list
      this.$router.push("/admin/locations/wards/list");
    },
    load_item() {
      this.$emit("on-show-loader");
      ServerClient.Locations.get_ward(
        {
          id: this.$route.params.id,
          is_edit: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          console.log("ward to be deleted ", res);
          if (res == null) {
            this.not_found = true;
          } else {
            this.ward = res;
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading ward details on admin delete ward ",
            errors
          );
        }
      );
    },
  },
  computed: {
    view_header_facts() {
      var facts = [
        {
          text: "City",
          val: this.ward.city.name,
        },
        { text: "District:", val: this.ward.district.name },
        { text: "Country:", val: this.ward.country.name },
      ];
      return facts;
    },
  },
  mounted() {
    var item_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Admin Delete Ward",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Locations",
          disabled: false,
          href: "/admin/locations",
        },
        {
          text: "Wards",
          disabled: false,
          href: "/admin/locations/wards/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/admin/locations/wards/list/view/" + item_id,
        },
        {
          text: "Delete",
          disabled: true,
          href:"/admin/locations/wards/list/view/"+item_id+"/delete" 
        }
      ],
      navbar_cols: 3
    });
    this.load_item();
  },
};
</script>